import { c as _c } from "react/compiler-runtime";
// Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.
// svgs/light/3.svg: path and width byte-identical (components/icons, Phase 5).
export default function Light3Icon(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M0 48c0-8.8 7.2-16 16-16l272 0c6.6 0 12.5 4 14.9 10.2s.8 13.1-4 17.6L120.9 224l71.1 0c70.7 0 128 57.3 128 128s-57.3 128-128 128L89.4 480c-36.4 0-69.6-20.5-85.9-53.1l-1.9-3.8c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l1.9 3.8C43 434.3 65.2 448 89.4 448L192 448c53 0 96-43 96-96s-43-96-96-96L80 256c-6.6 0-12.5-4-14.9-10.2s-.8-13.1 4-17.6L247.1 64 16 64C7.2 64 0 56.8 0 48z" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg aria-hidden="true" className={className} data-page-icon="light/3" fill="currentColor" focusable="false" height="1em" overflow="visible" viewBox="0 0 320 512" width="0.625em">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}